import { useContext } from "react";
import { ConfigurationRootStateContext } from "../context/EcsStateContext";
/**
 * Get the ecs state
 * - requires {@linkcode ConfigurationController}
 * ***Notes***
 * - Avoid using this, unless you absolutely need it
 * - If you need to, access the state using selectors
 * @category Hook
 * @category CsConfiguration
 * @export
 * @template TState Allows specifying an extended state
 * @returns {TState}
 */
export function useConfigurationRootState() {
    return useContext(ConfigurationRootStateContext);
}
//# sourceMappingURL=useConfigurationRootState.js.map